import React, { FunctionComponent } from 'react';
import Svg from '../../../core/icons/Svg';
import { useTheme } from '../../../core/hooks';

export interface CoverageIconProps {
  active?: boolean;
  completed?: boolean;
}

const CoverageIcon: FunctionComponent<CoverageIconProps> = ({
  active,
  completed,
  ...rest
}: CoverageIconProps) => {
  const theme = useTheme();
  let fillColor = '';
  let accentFillColor = '';
  if (active) {
    fillColor = theme.colors.primary;
    accentFillColor = theme.colors.tertiary;
  } else if (completed) {
    fillColor = theme.colors.primary;
    accentFillColor = theme.colors.primary;
  } else {
    fillColor = theme.colors.borderGray;
    accentFillColor = theme.colors.borderGray;
  }

  return (
    <Svg
      width="23px"
      height="26px"
      viewBox="0 0 23 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...rest}
    >
      <title>Coverage Icon</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Check-coverage"
          transform="translate(-890.000000, -216.000000)"
          fillRule="nonzero"
        >
          <g id="Group" transform="translate(505.000000, 209.000000)">
            <g id="Group-3" transform="translate(385.000000, 7.000000)">
              <path
                d="M10.2509254,0.132196637 L1.61426397,3.08106605 C0.647354548,3.40998344 1.47437618e-13,4.29708002 1.47437618e-13,5.2935697 L1.47437618e-13,13.92263 C1.47437618e-13,16.5509169 0.978775544,19.0826112 2.74185809,21.054848 C3.5723407,21.9856902 4.63050122,22.7600551 5.91410345,23.4337039 L10.590605,25.8853323 C10.882394,26.038301 11.2338488,26.0382178 11.5255611,25.8851111 L16.193799,23.4349628 C17.4739188,22.7623235 18.5322141,21.9864745 19.3627788,21.055338 C21.123178,19.0844824 22.1,16.5544306 22.1,13.9277292 L22.1,5.2935697 C22.1,4.29708002 21.4526455,3.40998344 20.4846624,3.08070013 L11.8503177,0.13262078 C11.3333938,-0.0441361725 10.7688221,-0.0441361725 10.2509254,0.132196637 Z M11.1969751,1.93636512 L19.83325,4.88510304 C20.0128549,4.94620078 20.1319402,5.10938815 20.1319402,5.2935697 L20.1319402,13.9277292 C20.1319402,16.0929071 19.3268421,18.1781794 17.8759755,19.8024979 L17.6183097,20.0755583 C16.9939215,20.7019326 16.207333,21.2539479 15.2580108,21.7527696 L11.0565602,23.956765 L6.84902929,21.7510581 C5.76068682,21.1798837 4.88857792,20.5416719 4.22832913,19.8016359 C2.77480317,18.1756777 1.96805984,16.0889608 1.96805984,13.92263 L1.96805984,5.2935697 C1.96805984,5.10938815 2.08714506,4.94620078 2.26567637,4.88546895 L10.9025966,1.93651145 C10.9979198,1.90405635 11.1024884,1.90405635 11.1969751,1.93636512 Z"
                id="Shield-Done"
                fill={fillColor}
              ></path>
              <path
                d="M14.5402491,9.41187117 C14.9245366,9.03849353 15.5475899,9.03849353 15.9318775,9.41187117 C16.2812299,9.75130539 16.3129892,10.2824645 16.0271554,10.6567578 L15.9318775,10.7639912 L10.817546,15.7331266 C10.4681284,16.0726242 9.9213259,16.1034215 9.53609643,15.8255646 L9.42573373,15.7329479 L6.94335425,13.3197685 C6.55916821,12.9462923 6.55933282,12.3409275 6.94372192,11.9676485 C7.29316656,11.628304 7.83985431,11.5975867 8.22500877,11.8754045 L8.33535033,11.9680058 L10.1210758,13.7048957 L14.5402491,9.41187117 Z"
                id="Stroke-3"
                fill={accentFillColor}
              ></path>
            </g>
          </g>
        </g>
      </g>
    </Svg>
  );
};

export default CoverageIcon;
